import { render, staticRenderFns } from "./page6.vue?vue&type=template&id=1a60912d&"
import script from "./page6.vue?vue&type=script&lang=js&"
export * from "./page6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports